// extracted by mini-css-extract-plugin
module.exports = {"container":"_2wXjUt","title":"_3yghxi","headline":"_1TrKB_","productCount":"_23ICc0","titleWrapper":"_1OmVHg","desc":"_15Q2sD","shine-lines":"_5kuR0l"};